unit CommoditySetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client, Vcl.StdCtrls,
  WEBLib.StdCtrls, VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.Controls,
  WEBLib.DBCtrls, WEBLib.ExtCtrls, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, WEBLib.Buttons;

type
  TfrmCommoditySetup = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    WebButton1: TButton;
    WebButton2: TButton;
    WebButton3: TButton;
    wcCommodityPrices: TXDataWebClient;
    wdsCommodityPrices: TXDataWebDataSet;
    dsCommodityPrices: TDataSource;
    wdsCommodityPricesAUTONO: TIntegerField;
    wdsCommodityPricesCommoditiesno: TIntegerField;
    wdsCommodityPricesCOSTPRICE: TFloatField;
    wdsCommodityPricesCONFIREMED: TStringField;
    dgdbaCommoditiesPrices: TTMSFNCDataGridDatabaseAdapter;
    wcCommodities: TXDataWebClient;
    wdsCommodities: TXDataWebDataSet;
    wdsCommoditiesNO: TIntegerField;
    wdsCommoditiesNAME: TStringField;
    wdsCommoditiesITEMCODE: TStringField;
    wdsCommoditiesSTORE: TIntegerField;
    wdsCommoditiesUNITNUMBER: TStringField;
    wdsCommoditiesDENSITY: TFloatField;
    dsCommodities: TDataSource;
    WebButton4: TButton;
    WebButton5: TButton;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtCommoditiesPriceListPC: TEdit;
    wdsCommodityPricesSTARTDATE: TStringField;
    wdsCommodityPricesENDDATE: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton5Click(Sender: TObject);
    procedure WebButton4Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
  private
    { Private declarations }

    iCommoditiesPriceListMaxPC, iCommoditiesPriceListPC : Integer;

    procedure LoadCommodityPriceList(iAutoNo, iPageCount, iCommodityNo : integer; sConfirmed : String);
    procedure LoadComodity;
  public
    { Public declarations }
    iState, iNo : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmCommoditySetup: TfrmCommoditySetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common, share.classes, CommodityPriceSetup;

procedure TfrmCommoditySetup.LoadCommodityPriceList(iAutoNo, iPageCount,
  iCommodityNo: integer; sConfirmed: String);
var
  ComodityPriceListParams : TComodityPriceListParams;
  sJsonParams : String;

  procedure OnError(Error: TXDataClientError);
    begin
      LoadCommodityPriceList(iAutoNo, iPageCount, iCommodityNo, sConfirmed);
    end;

   procedure OnResulPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadCommodityPriceList(iAutoNo, iPageCount, iCommodityNo, sConfirmed);
        end
      else
        begin
          wdsCommodityPrices.Close;
          wdsCommodityPrices.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCommodityPrices.Open;
        end;
    end;

    procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadCommodityPriceList(iAutoNo, iPageCount, iCommodityNo, sConfirmed);
        end
      else
        begin
           iCommoditiesPriceListMaxPC := Integer(TJSObject(Response.Result)['value']);

           edtCommoditiesPriceListPC.Text := IntToStr(iCommoditiesPriceListPC) + ' of ' + IntToStr(iCommoditiesPriceListMaxPC);

          wcCommodityPrices.RawInvoke('IstfmsloadsService.Get_CommodityPriceList_View',[sJsonParams],@OnResulPC,@OnError);
        end;
    end;

begin
  ComodityPriceListParams := TComodityPriceListParams.Create;
  ComodityPriceListParams.AutoNo := iAutoNo;
  ComodityPriceListParams.PageCount := iPageCount;
  ComodityPriceListParams.CommoditiesNo := iCommodityNo;
  ComodityPriceListParams.Confirmed := sConfirmed;

  sJsonParams := ConvertObjToJson(ComodityPriceListParams).ToJSON;
  console.log(sJsonParams);
  wcCommodityPrices.RawInvoke('IstfmsloadsService.Get_commodityPriceList_MaxPC',[sJsonParams],@OnResult,@OnError);

end;

procedure TfrmCommoditySetup.LoadComodity;
var
  CommoditiesParams : TCommoditiesParams;
  JsonParams : String;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadComodity
    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadComodity
        end
      else
        begin
          wdsCommodities.Close;
          wdsCommodities.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCommodities.Open;

          wdsCommodities.Edit;
        end;
    end;

begin

  CommoditiesParams := TCommoditiesParams.Create;
  CommoditiesParams.PageCount := -1;
  CommoditiesParams.No := iNo;

  JsonParams := ConvertObjToJson(CommoditiesParams).ToJSON;

  wcCommodities.RawInvoke('IstfmsloadsService.Get_Commodities_View',[JsonParams],@OnResult,@OnError);
end;

procedure TfrmCommoditySetup.TMSFNCDataGrid1CellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
  newform : TfrmCommodityPriceSetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          LoadCommodityPriceList(-1, 1, iNo, '*');
        end;
    end;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iCommodityNo := iNo;
          iPriceNo := dgdbaCommoditiesPrices.FieldAtColumn[1].AsInteger;
          iState := 2;
        end;
    end;
begin
  if AColumn = 7 then
    Begin
      newform := TfrmCommodityPriceSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.ShowModal(@AfterShowModal);
    End;
end;

procedure TfrmCommoditySetup.WebButton1Click(Sender: TObject);
var
  newform : TfrmCommodityPriceSetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          LoadCommodityPriceList(-1,iCommoditiesPriceListPC,ino,'*');
        end;
    end;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
          iCommodityNo := iNo;
        end;
    end;
begin
  newform := TfrmCommodityPriceSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmCommoditySetup.WebButton4Click(Sender: TObject);
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Commodity Successfully saved.');
      Close;
    end;
begin
  case iState of
    1 : Begin
          wcCommodities.RawInvoke('IstfmsloadsService.Put_Commodity_Insert',[GetJsonFromDataSet(wdsCommodities)],@OnSuccess,@OnError);
        End;

    2 : begin
          wcCommodities.RawInvoke('IstfmsloadsService.Put_Commodity_Edit',[GetJsonFromDataSet(wdsCommodities)],@OnSuccess,@OnError);
        end;
  end;

end;

procedure TfrmCommoditySetup.WebButton5Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmCommoditySetup.WebFormShow(Sender: TObject);

begin

  iCommoditiesPriceListPC := 1 ;

  case iState of
    1 : Begin
          wdsCommodities.Open;
          wdsCommodities.Insert;
        End;

    2 : begin
          LoadComodity;
          LoadCommodityPriceList(-1, 1, iNo, '*');
        end;
  end;
end;

procedure TfrmCommoditySetup.WebSpeedButton1Click(Sender: TObject);
begin
  iCommoditiesPriceListPC := 1;
  LoadCommodityPriceList(-1, iCommoditiesPriceListPC, iNo, '*');
end;

procedure TfrmCommoditySetup.WebSpeedButton2Click(Sender: TObject);
begin
  if iCommoditiesPriceListPC > 1 then
    Begin
      iCommoditiesPriceListPC := iCommoditiesPriceListPC - 1;
      LoadCommodityPriceList(-1, iCommoditiesPriceListPC, iNo, '*');
    End;
end;

procedure TfrmCommoditySetup.WebSpeedButton3Click(Sender: TObject);
begin
  if iCommoditiesPriceListPC < iCommoditiesPriceListMaxPC then
    Begin
      iCommoditiesPriceListPC := iCommoditiesPriceListPC + 1;
      LoadCommodityPriceList(-1, iCommoditiesPriceListPC, iNo, '*');
    End;

end;

procedure TfrmCommoditySetup.WebSpeedButton4Click(Sender: TObject);
begin
  iCommoditiesPriceListPC := iCommoditiesPriceListMaxPC;
  LoadCommodityPriceList(-1, iCommoditiesPriceListPC, iNo, '*');
end;

procedure TfrmCommoditySetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton4 := TButton.Create(Self);
  WebButton5 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaCommoditiesPrices := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtCommoditiesPriceListPC := TEdit.Create(Self);
  wcCommodityPrices := TXDataWebClient.Create(Self);
  wdsCommodityPrices := TXDataWebDataSet.Create(Self);
  wdsCommodityPricesAUTONO := TIntegerField.Create(Self);
  wdsCommodityPricesCommoditiesno := TIntegerField.Create(Self);
  wdsCommodityPricesCOSTPRICE := TFloatField.Create(Self);
  wdsCommodityPricesCONFIREMED := TStringField.Create(Self);
  wdsCommodityPricesSTARTDATE := TStringField.Create(Self);
  wdsCommodityPricesENDDATE := TStringField.Create(Self);
  dsCommodityPrices := TDataSource.Create(Self);
  wcCommodities := TXDataWebClient.Create(Self);
  wdsCommodities := TXDataWebDataSet.Create(Self);
  wdsCommoditiesNO := TIntegerField.Create(Self);
  wdsCommoditiesNAME := TStringField.Create(Self);
  wdsCommoditiesITEMCODE := TStringField.Create(Self);
  wdsCommoditiesSTORE := TIntegerField.Create(Self);
  wdsCommoditiesUNITNUMBER := TStringField.Create(Self);
  wdsCommoditiesDENSITY := TFloatField.Create(Self);
  dsCommodities := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton4.BeforeLoadDFMValues;
  WebButton5.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaCommoditiesPrices.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtCommoditiesPriceListPC.BeforeLoadDFMValues;
  wcCommodityPrices.BeforeLoadDFMValues;
  wdsCommodityPrices.BeforeLoadDFMValues;
  wdsCommodityPricesAUTONO.BeforeLoadDFMValues;
  wdsCommodityPricesCommoditiesno.BeforeLoadDFMValues;
  wdsCommodityPricesCOSTPRICE.BeforeLoadDFMValues;
  wdsCommodityPricesCONFIREMED.BeforeLoadDFMValues;
  wdsCommodityPricesSTARTDATE.BeforeLoadDFMValues;
  wdsCommodityPricesENDDATE.BeforeLoadDFMValues;
  dsCommodityPrices.BeforeLoadDFMValues;
  wcCommodities.BeforeLoadDFMValues;
  wdsCommodities.BeforeLoadDFMValues;
  wdsCommoditiesNO.BeforeLoadDFMValues;
  wdsCommoditiesNAME.BeforeLoadDFMValues;
  wdsCommoditiesITEMCODE.BeforeLoadDFMValues;
  wdsCommoditiesSTORE.BeforeLoadDFMValues;
  wdsCommoditiesUNITNUMBER.BeforeLoadDFMValues;
  wdsCommoditiesDENSITY.BeforeLoadDFMValues;
  dsCommodities.BeforeLoadDFMValues;
  try
    Name := 'frmCommoditySetup';
    Width := 800;
    Height := 400;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 800;
    WebPanel1.Height := 400;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 40;
    WebLabel1.Top := 111;
    WebLabel1.Width := 60;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Description';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 40;
    WebLabel2.Top := 176;
    WebLabel2.Width := 55;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Item Code';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 40;
    WebLabel3.Top := 240;
    WebLabel3.Width := 27;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Store';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 240;
    WebLabel4.Top := 176;
    WebLabel4.Width := 39;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Density';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 240;
    WebLabel5.Top := 240;
    WebLabel5.Width := 69;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Unit Number';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 800;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Commodity Setup';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 340;
    WebPanel3.Width := 800;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton4.SetParentComponent(WebPanel3);
    WebButton4.Name := 'WebButton4';
    WebButton4.Left := 24;
    WebButton4.Top := 16;
    WebButton4.Width := 96;
    WebButton4.Height := 25;
    WebButton4.Caption := 'Save';
    WebButton4.Color := clGreenyellow;
    WebButton4.HeightPercent := 100.000000000000000000;
    WebButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton4, Self, 'OnClick', 'WebButton4Click');
    WebButton5.SetParentComponent(WebPanel3);
    WebButton5.Name := 'WebButton5';
    WebButton5.Left := 136;
    WebButton5.Top := 16;
    WebButton5.Width := 96;
    WebButton5.Height := 25;
    WebButton5.Caption := 'Cancel';
    WebButton5.Color := clRed;
    WebButton5.ChildOrder := 1;
    WebButton5.HeightPercent := 100.000000000000000000;
    WebButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton5, Self, 'OnClick', 'WebButton5Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 40;
    WebDBEdit1.Top := 132;
    WebDBEdit1.Width := 321;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'NAME';
    WebDBEdit1.DataSource := dsCommodities;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 40;
    WebDBEdit2.Top := 197;
    WebDBEdit2.Width := 121;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 3;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit2';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'ITEMCODE';
    WebDBEdit2.DataSource := dsCommodities;
    WebDBEdit3.SetParentComponent(WebPanel1);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 40;
    WebDBEdit3.Top := 261;
    WebDBEdit3.Width := 121;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 4;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'STORE';
    WebDBEdit3.DataSource := dsCommodities;
    WebDBEdit4.SetParentComponent(WebPanel1);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 240;
    WebDBEdit4.Top := 197;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 5;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit4';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'DENSITY';
    WebDBEdit4.DataSource := dsCommodities;
    WebDBEdit5.SetParentComponent(WebPanel1);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 240;
    WebDBEdit5.Top := 261;
    WebDBEdit5.Width := 121;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 6;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit5';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'UNITNUMBER';
    WebDBEdit5.DataSource := dsCommodities;
    TMSFNCDataGrid1.SetParentComponent(WebPanel1);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 392;
    TMSFNCDataGrid1.Top := 109;
    TMSFNCDataGrid1.Width := 385;
    TMSFNCDataGrid1.Height := 202;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 7;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaCommoditiesPrices;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 9;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'AutoNo';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CommoditiesNo';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Start Date';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'End Date';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cost Price';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Confirmed';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('CommoditySetup.WebPanel1.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'TMSFNCDataGrid1CellClick');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaCommoditiesPrices.SetParentComponent(TMSFNCDataGrid1);
    dgdbaCommoditiesPrices.Name := 'dgdbaCommoditiesPrices';
    dgdbaCommoditiesPrices.Left := 261;
    dgdbaCommoditiesPrices.Top := 62;
    dgdbaCommoditiesPrices.Width := 26;
    dgdbaCommoditiesPrices.Height := 26;
    dgdbaCommoditiesPrices.Visible := True;
    dgdbaCommoditiesPrices.Columns.Clear;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      Header := '.';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      FieldName := 'AUTONO';
      Header := 'AutoNo';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      FieldName := 'Commoditiesno';
      Header := 'CommoditiesNo';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      FieldName := 'STARTDATE';
      Header := 'Start Date';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      FieldName := 'ENDDATE';
      Header := 'End Date';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      FieldName := 'COSTPRICE';
      Header := 'Cost Price';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      FieldName := 'CONFIREMED';
      Header := 'Confirmed';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dgdbaCommoditiesPrices.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dgdbaCommoditiesPrices.DataSource := dsCommodityPrices;
    WebButton1.SetParentComponent(WebPanel1);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 420;
    WebButton1.Top := 66;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'New Price';
    WebButton1.ChildOrder := 13;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel1);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 532;
    WebButton2.Top := 66;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Confirm Price';
    WebButton2.ChildOrder := 14;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    WebButton3.SetParentComponent(WebPanel1);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 644;
    WebButton3.Top := 66;
    WebButton3.Width := 96;
    WebButton3.Height := 25;
    WebButton3.Caption := 'Open Price';
    WebButton3.ChildOrder := 15;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(WebPanel1);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 531;
    WebSpeedButton1.Top := 317;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 11;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel1);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 555;
    WebSpeedButton2.Top := 317;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 12;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel1);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 628;
    WebSpeedButton3.Top := 317;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 13;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel1);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 652;
    WebSpeedButton4.Top := 317;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 14;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    edtCommoditiesPriceListPC.SetParentComponent(WebPanel1);
    edtCommoditiesPriceListPC.Name := 'edtCommoditiesPriceListPC';
    edtCommoditiesPriceListPC.Left := 579;
    edtCommoditiesPriceListPC.Top := 317;
    edtCommoditiesPriceListPC.Width := 49;
    edtCommoditiesPriceListPC.Height := 24;
    edtCommoditiesPriceListPC.Alignment := taCenter;
    edtCommoditiesPriceListPC.ChildOrder := 20;
    edtCommoditiesPriceListPC.HeightPercent := 100.000000000000000000;
    edtCommoditiesPriceListPC.Text := '0 of 0';
    edtCommoditiesPriceListPC.WidthPercent := 100.000000000000000000;
    wcCommodityPrices.SetParentComponent(Self);
    wcCommodityPrices.Name := 'wcCommodityPrices';
    wcCommodityPrices.Connection := dmData.dbConnect;
    wcCommodityPrices.Left := 464;
    wcCommodityPrices.Top := 170;
    wdsCommodityPrices.SetParentComponent(Self);
    wdsCommodityPrices.Name := 'wdsCommodityPrices';
    wdsCommodityPrices.Connection := dmData.dbConnect;
    wdsCommodityPrices.Left := 536;
    wdsCommodityPrices.Top := 170;
    wdsCommodityPricesAUTONO.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesAUTONO.Name := 'wdsCommodityPricesAUTONO';
    wdsCommodityPricesAUTONO.FieldName := 'AUTONO';
    wdsCommodityPricesCommoditiesno.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesCommoditiesno.Name := 'wdsCommodityPricesCommoditiesno';
    wdsCommodityPricesCommoditiesno.FieldName := 'Commoditiesno';
    wdsCommodityPricesCOSTPRICE.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesCOSTPRICE.Name := 'wdsCommodityPricesCOSTPRICE';
    wdsCommodityPricesCOSTPRICE.FieldName := 'COSTPRICE';
    wdsCommodityPricesCONFIREMED.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesCONFIREMED.Name := 'wdsCommodityPricesCONFIREMED';
    wdsCommodityPricesCONFIREMED.FieldName := 'CONFIREMED';
    wdsCommodityPricesSTARTDATE.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesSTARTDATE.Name := 'wdsCommodityPricesSTARTDATE';
    wdsCommodityPricesSTARTDATE.FieldName := 'STARTDATE';
    wdsCommodityPricesENDDATE.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesENDDATE.Name := 'wdsCommodityPricesENDDATE';
    wdsCommodityPricesENDDATE.FieldName := 'ENDDATE';
    dsCommodityPrices.SetParentComponent(Self);
    dsCommodityPrices.Name := 'dsCommodityPrices';
    dsCommodityPrices.DataSet := wdsCommodityPrices;
    dsCommodityPrices.Left := 608;
    dsCommodityPrices.Top := 170;
    wcCommodities.SetParentComponent(Self);
    wcCommodities.Name := 'wcCommodities';
    wcCommodities.Connection := dmData.dbConnect;
    wcCommodities.Left := 64;
    wcCommodities.Top := 24;
    wdsCommodities.SetParentComponent(Self);
    wdsCommodities.Name := 'wdsCommodities';
    wdsCommodities.Connection := dmData.dbConnect;
    wdsCommodities.Left := 128;
    wdsCommodities.Top := 24;
    wdsCommoditiesNO.SetParentComponent(wdsCommodities);
    wdsCommoditiesNO.Name := 'wdsCommoditiesNO';
    wdsCommoditiesNO.FieldName := 'NO';
    wdsCommoditiesNAME.SetParentComponent(wdsCommodities);
    wdsCommoditiesNAME.Name := 'wdsCommoditiesNAME';
    wdsCommoditiesNAME.FieldName := 'NAME';
    wdsCommoditiesITEMCODE.SetParentComponent(wdsCommodities);
    wdsCommoditiesITEMCODE.Name := 'wdsCommoditiesITEMCODE';
    wdsCommoditiesITEMCODE.FieldName := 'ITEMCODE';
    wdsCommoditiesSTORE.SetParentComponent(wdsCommodities);
    wdsCommoditiesSTORE.Name := 'wdsCommoditiesSTORE';
    wdsCommoditiesSTORE.FieldName := 'STORE';
    wdsCommoditiesUNITNUMBER.SetParentComponent(wdsCommodities);
    wdsCommoditiesUNITNUMBER.Name := 'wdsCommoditiesUNITNUMBER';
    wdsCommoditiesUNITNUMBER.FieldName := 'UNITNUMBER';
    wdsCommoditiesDENSITY.SetParentComponent(wdsCommodities);
    wdsCommoditiesDENSITY.Name := 'wdsCommoditiesDENSITY';
    wdsCommoditiesDENSITY.FieldName := 'DENSITY';
    dsCommodities.SetParentComponent(Self);
    dsCommodities.Name := 'dsCommodities';
    dsCommodities.DataSet := wdsCommodities;
    dsCommodities.Left := 200;
    dsCommodities.Top := 24;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton4.AfterLoadDFMValues;
    WebButton5.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaCommoditiesPrices.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtCommoditiesPriceListPC.AfterLoadDFMValues;
    wcCommodityPrices.AfterLoadDFMValues;
    wdsCommodityPrices.AfterLoadDFMValues;
    wdsCommodityPricesAUTONO.AfterLoadDFMValues;
    wdsCommodityPricesCommoditiesno.AfterLoadDFMValues;
    wdsCommodityPricesCOSTPRICE.AfterLoadDFMValues;
    wdsCommodityPricesCONFIREMED.AfterLoadDFMValues;
    wdsCommodityPricesSTARTDATE.AfterLoadDFMValues;
    wdsCommodityPricesENDDATE.AfterLoadDFMValues;
    dsCommodityPrices.AfterLoadDFMValues;
    wcCommodities.AfterLoadDFMValues;
    wdsCommodities.AfterLoadDFMValues;
    wdsCommoditiesNO.AfterLoadDFMValues;
    wdsCommoditiesNAME.AfterLoadDFMValues;
    wdsCommoditiesITEMCODE.AfterLoadDFMValues;
    wdsCommoditiesSTORE.AfterLoadDFMValues;
    wdsCommoditiesUNITNUMBER.AfterLoadDFMValues;
    wdsCommoditiesDENSITY.AfterLoadDFMValues;
    dsCommodities.AfterLoadDFMValues;
  end;
end;

end.